export const backendUrl = 'https://roomforbread.odoo.com/api';

export function currencyFormat(num) {
  return '$' + (num / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export const deliveryDay = 'Fri. July 12th - Sun. 14th';
export const deliveryTime = '8 AM - 10 PM';
